import React from 'react';
import { CardContent } from '@material-ui/core';

const ResponsiveCardContent: React.FC = ({ children }) => {
  return (
    <CardContent>
      {children}
    </CardContent>
  )
}

export default ResponsiveCardContent;
